import { FormContainer, FormInput, useFetch } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  createTicketDefaultDocCategory,
  getTicketDefaultDocCategoryById,
  updateTicketDefaultDocCategoryById,
} from "../../../../../../services/ticketDefaultDocCategory.service";
import {
  ticketDefaultDocCategorySchema,
  TTicketDefaultDocCategoryForm,
} from "./TicketDefaultDocCategorySchema";

const translationPath = "page.settings.crm.ticketDefaultDocCategories.";

const TicketDefaultDocCategory = () => {
  const { t } = useTranslation();

  const { sendRequest: save, loading: sLoading } = useFetch(
    createTicketDefaultDocCategory
  );

  const { sendRequest: update, loading: uLoading } = useFetch(
    updateTicketDefaultDocCategoryById
  );

  const { sendRequest: get, loading: gLoading } = useFetch(
    getTicketDefaultDocCategoryById
  );

  const handleUpdate = (v: TTicketDefaultDocCategoryForm, id: string) => {
    return update({
      item: v,
      id: id,
    });
  };

  const loading = sLoading || uLoading || gLoading;

  return (
    <FormContainer<TTicketDefaultDocCategoryForm>
      saveFunction={save}
      updateFunction={handleUpdate}
      getFunction={get}
      loading={loading}
      title={t(translationPath + "ticket_default_doc_category")}
      schema={ticketDefaultDocCategorySchema}
      subtitle={t(translationPath + "new_ticket_default_doc_category")}
      subtitleWatchField={"name"}
      fields={() => (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <FormInput
              size="small"
              name="name"
              label={t(translationPath + "name")}
              inputProps={{
                maxLength: 255,
              }}
              fullWidth
              autoFocus
            />
          </Grid>
        </Grid>
      )}
    />
  );
};

export default TicketDefaultDocCategory;
